module.exports = __webpack_public_path__ + "img/Restaurant11.1c283780.png";